import { io } from "socket.io-client";
import useAuthStore from "../store/useAuthStore";

// Use environment variable or fallback to localhost
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5000";

let socket = null;

export const connectSocket = () => {
  const token = useAuthStore.getState().token;
  const user = useAuthStore.getState().user;
  
  console.log('🔌 Connecting socket with user:', user?.id, 'token:', token ? 'present' : 'missing');
  console.log('🔌 Socket URL:', SOCKET_URL);
  
  if (!token) {
    console.error('❌ Cannot connect socket: No token available');
    return null;
  }
  
  if (!socket || !socket.connected) {
    socket = io(SOCKET_URL, {
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000,
      auth: {
        token: token,
        /*
         * Solo la usa el superadministrador, que no pertenece a ninguna
         * residencial y tiene que decir a cuál entra. Para el resto, el
         * servidor la resuelve desde el usuario y esto se ignora: una
         * residencial ajena enviada desde el navegador no abre nada.
         */
        residentialId: useAuthStore.getState().residentialSeleccionada || undefined,
      },
    });

    // Connection event handlers
    socket.on("connect", () => {
      console.log("Socket connected:", socket.id);
    });

    // Listen for server confirmation of connection
    socket.on("connected", (data) => {
      console.log("Socket authenticated and connected:", data);
    });

    socket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
    });

    // Socket reconnection is automatic with auth in middleware
    socket.on("reconnect", () => {
      console.log("Socket reconnected");
    });

    socket.on("connect_error", (error) => {
      console.error("❌ Socket connection error:", error.message);
      console.error("   Error type:", error.type);
      console.error("   Error data:", error.data);
      
      // Log more details about the connection attempt
      console.log("   Token present:", !!token);
      console.log("   Socket URL:", SOCKET_URL);
      console.log("   Auth object:", socket.auth);
    });

    socket.on("error", (error) => {
      console.error("❌ Socket error:", error);
    });
  }

  return socket;
};

export const disconnectSocket = () => {
  if (socket && socket.connected) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => {
  if (!socket || !socket.connected) {
    return connectSocket();
  }
  return socket;
};

// Auto-connect when module loads if user is authenticated
// Add a small delay to ensure auth store is fully initialized
setTimeout(() => {
  if (useAuthStore.getState().token) {
    console.log('🔌 Auto-connecting socket on module load');
    connectSocket();
  }
}, 100);

// Subscribe to auth changes
useAuthStore.subscribe(
  (state) => state.token,
  (token) => {
    if (token) {
      console.log('🔌 Token changed, connecting socket');
      // Add small delay to ensure state is fully updated
      setTimeout(() => connectSocket(), 100);
    } else {
      console.log('🔌 Token removed, disconnecting socket');
      disconnectSocket();
    }
  }
);

// Force reconnect with new token
export const reconnectSocket = () => {
  console.log('🔄 Force reconnecting socket...');
  disconnectSocket();
  return connectSocket();
};

// Get socket status
export const getSocketStatus = () => {
  return {
    connected: socket?.connected || false,
    id: socket?.id || null,
    connecting: socket?.connecting || false,
    disconnected: socket?.disconnected || true,
  };
};

export default {
  connect: connectSocket,
  disconnect: disconnectSocket,
  get: getSocket,
  reconnect: reconnectSocket,
  status: getSocketStatus,
};